import ChangePageButtons from "../../../components/ChangePageButtons";
import Definitions from "../../../components/Definitions";
import Disclosures from "../../../components/Disclosures";
import CouponCashFlowReport from "../../../components/Reports/CouponCashFlowReport";
import CoverPage from "../../../components/Reports/CoverPage";
import CreditQualityReport from "../../../components/Reports/CreditQualityReport";
import InterestRateAnalysisReport from "../../../components/Reports/InterestRateAnalysisReport";
import KeyRateDurationsReport from "../../../components/Reports/KeyRateDurationsReport";
import MaturityReport from "../../../components/Reports/MaturityReport";
import OneSheeterReport from "../../../components/Reports/OneSheeterReport";
import PortfolioCharacteristicsReport from "../../../components/Reports/PortfolioCharacteristicsReport";
import ProposedSellsReport from "../../../components/Reports/ProposedSellsReport";
import ScenarioAnalysisReport from "../../../components/Reports/ScenarioAnalysisReport";
import TransitionSummaryReport from "../../../components/Reports/TransitionSummaryReport";
import StaticPageReport from "../../../components/StaticPageReport";
import useOutputReportStore from "../../../store/OutputReport.store";
import { definitions } from "../../../utils/resources/definitionsCopy";
import { disclosuresCopy } from "../../../utils/resources/disclosuresCopy";

const TransitionTreasuryReport = () => {
  const data = useOutputReportStore((state) => state.data);
  const types = useOutputReportStore((state) => state.types);

  const disclosuresArgs = {
    heading: "Disclosures",
    className: "report-article",
    bodyContent: [
      {
        heading: "Marketing Communication",
        content: disclosuresCopy.report.body,
      },
    ],
    footnote: disclosuresCopy.report.footnote,
  };

  const definitionsArgs = {
    className: "report-article",
    bodyContent: [
      {
        heading: definitions.headings.explanation,
        cardContent: [
          definitions.taxLiability,
          definitions.balance,
          definitions.minTrackingError,
        ],
        content: [
          definitions.currentPortfolio,
          definitions.reinvestProceeds,
          definitions.referenceIndex.fixedIncome,
        ],
      },
      {
        heading: definitions.headings.keyTerms,
        content: [
          definitions.betaToIndex,
          definitions.callable,
          definitions.couponTransition,
          definitions.creditQuality,
          definitions.table.creditQuality,
          definitions.durationTimeSpread,
          definitions.effectiveDuration,
          definitions.keyRateDuration,
          definitions.liquidityScore,
          definitions.maturityDate,
          definitions.model,
          definitions.optionAdjustedSpread,
          definitions.optionAdjustedSpreadDuration,
          definitions.price,
          definitions.timeToMaturity,
          definitions.yieldToMaturity,
          definitions.yieldToWorst,
        ],
      },
      definitions.transitionSummary,
    ],
    footnote: definitions.footnote.transition.treasury,
  };

  return (
    <>
      <CoverPage />
      {data && types && (
        <>
          <StaticPageReport />
          <OneSheeterReport />
          <TransitionSummaryReport />
          <PortfolioCharacteristicsReport />
          <CouponCashFlowReport />
          <MaturityReport />
          <CreditQualityReport />
          <KeyRateDurationsReport />
          <ProposedSellsReport />
          <InterestRateAnalysisReport />
          <ScenarioAnalysisReport />
          <Definitions {...definitionsArgs} />
          <Disclosures {...disclosuresArgs} />
        </>
      )}
      <ChangePageButtons />
    </>
  );
};

export default TransitionTreasuryReport;
